import initPhotoSwipeLightbox from '../modules/photoswipeLightbox'

let sundayHeaderMusicObserver = null

function initSundayIntroAuthor() {
  const root = document.querySelector('.single-sunday .sunday-contents')
  if (!root) return

  const authors = root.dataset.commentAuthors
  if (!authors) return

  const firstIntro = root.querySelector('p.sunday-intro')
  if (!firstIntro) return

  const authorEl = document.createElement('strong')
  authorEl.textContent = authors
  firstIntro.insertBefore(document.createElement('br'), firstIntro.firstChild)
  firstIntro.insertBefore(authorEl, firstIntro.firstChild)
}

function initSundayCommentDrawer() {
  const root = document.querySelector('.single-sunday .sunday-contents')
  if (!root) return

  const exceedsClampLines = (el, lines = 5) => {
    const styles = window.getComputedStyle(el)
    let lineHeight = parseFloat(styles.lineHeight)
    if (!Number.isFinite(lineHeight)) {
      const fontSize = parseFloat(styles.fontSize) || 16
      lineHeight = fontSize * 1.4
    }
    const maxHeight = lineHeight * lines
    return el.scrollHeight > maxHeight + 1
  }

  const commentBlocks = root.querySelectorAll('p.sunday-comment, p.sunday-comment-drawer')
  commentBlocks.forEach((commentEl) => {
    const isCollapsible = exceedsClampLines(commentEl, 5)
    const wrapper = document.createElement('div')
    wrapper.className = 'sunday-comment-drawer'
    commentEl.parentNode.insertBefore(wrapper, commentEl)
    wrapper.appendChild(commentEl)
    commentEl.classList.add('sunday-comment-body')

    if (!isCollapsible) {
      wrapper.setAttribute('aria-expanded', 'true')
      return
    }

    const arrow = document.createElement('button')
    arrow.className = 'sunday-comment-arrow'
    arrow.setAttribute('aria-label', 'Expand comment')
    arrow.setAttribute('aria-expanded', 'false')
    arrow.setAttribute('type', 'button')
    wrapper.appendChild(arrow)

    wrapper.setAttribute('aria-expanded', 'false')

    arrow.addEventListener('click', () => {
      const isExpanded = wrapper.getAttribute('aria-expanded') === 'true'
      const nextExpanded = !isExpanded
      wrapper.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false')
      arrow.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false')
      arrow.setAttribute('aria-label', nextExpanded ? 'Collapse comment' : 'Expand comment')
    })
  })
}

export default {
  init() {
    // Skip Art template (uses OpenSeadragon)
    if (document.body.classList.contains('sunday-template-sunday-art')) return

    initPhotoSwipeLightbox('.single-sunday .sunday-contents', { forceGallery: true })
    initSundayIntroAuthor()
    initSundayCommentDrawer()

    const el = document.getElementById('sunday-header-music')
    if (el) {
      sundayHeaderMusicObserver?.disconnect()
      sundayHeaderMusicObserver = null

      let wasAboveTop = null
      const rootBottom = () =>
        window.innerHeight

      sundayHeaderMusicObserver = new IntersectionObserver(
        ([entry]) => {
          const top = entry.boundingClientRect.top

          // Tutto sotto il fold: non è il passaggio dal top della viewport
          if (top > rootBottom()) return

          const aboveTop = top < 0

          if (wasAboveTop === null) {
            wasAboveTop = aboveTop
            return
          }
          if (wasAboveTop === aboveTop) return

          wasAboveTop = aboveTop
          const sidebarMusic = document.getElementById('sidebar-music-reveal')
          if (sidebarMusic) {
            sidebarMusic.style.opacity = aboveTop ? '1' : '0'
            sidebarMusic.classList.toggle('pointer-events-none', !aboveTop)
          }
        },
        {
          // Più soglie → più callback mentre l’elemento si muove; serve a catturare top ≈ 0
          threshold: Array.from({ length: 101 }, (_, i) => i / 100),
        }
      )
      sundayHeaderMusicObserver.observe(el)
    }
  },
  finalize() {
    // Il Router invoca finalize subito dopo init sulla stessa pagina (vedi Router.loadEvents).
    // Non disconnettere qui l’observer o non ricevi più callback né console.log.
  },
}
